export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Education.fafcd530.png";